import Icon from '../components/Icon.vue'

Icon.register({
  'file-import': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M16 288C7.2 288 0 295.2 0 304V336C0 344.8 7.2 352 16 352H128V288H16zM352 136V0H152C138.7 0 128 10.7 128 24V288H256V222.8C256 208.5 273.3 201.4 283.4 211.6L379.1 308C385.7 314.6 385.7 325.4 379.1 332L283.4 428.4C273.3 438.6 256 431.4 256 417.2V352H128V488C128 501.3 138.7 512 152 512H488C501.3 512 512 501.3 512 488V160H376C362.8 160 352 149.2 352 136zM505 105L407.1 7C402.6 2.5 396.5 0 390.1 0H384V128H512V121.9C512 115.6 509.5 109.5 505 105z'
      }
    ]
  }
})
